import i18n from '../../../../i18n';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
const cm = (key, opts) => i18n.t(`serviceMessages.common.${key}`, opts);

export const apiCall = async (endpoint, method = 'GET', data = null) => {
  const options = {
    method,
    headers: { 'Content-Type': 'application/json' },
  };
  if (data) options.body = JSON.stringify(data);

  try {
    const response = await fetch(`${API_BASE}${endpoint}`, options);
    const result = await response.json();
    if (!response.ok) throw new Error(result.error || cm('http_error', { status: response.status }));
    return result;
  } catch (error) {
    console.error(`API Error (${method} ${endpoint}):`, error);
    throw error;
  }
};
